import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defaultIntegracaoBancaria, TConfiguracaoBancaria } from "../../types/api/financeiro/configuracoes-bancarias";

export default function SelectIntegracaoBancaria({
  value,
  onChange,
  required = false,
  error = false,
  possuiBtnLimpar = false,
  multiple = false,
  extraParams = {},
  label = "Integração bancária"
}: SelectSimpleApiQueryProps) {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => setOpenModal(false);

  const inputLabel = (() => {
    if (!value) return "";
    if (Array.isArray(value)) {
      return value.map((item) => item.id).join(", ");
    } else {
      return `${value.id ?? ""}${value.nome_banco ? ` - ${value.nome_banco}` : ""}`;
    }
  })();

  return (
    <>
      <TextField
        {...{ required, error }}
        label={label}
        variant="outlined"
        fullWidth
        onClick={() => setOpenModal(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenModal(true);
          }
        }}
        slotProps={{
          input: { readOnly: true }
        }}
        value={inputLabel}
        helperText={error ? "Campo obrigatório" : ""}
      />

      {openModal && (
        <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
          <DialogContentSelectGeneric
            {...{ handleClose, possuiBtnLimpar, multiple, extraParams }}
            title={`Selecionar ${label}`}
            queryPath="/financeiro/configuracoes/pesquisar-configuracoes-bancarias"
            getItemKey={(item) => item.id}
            defaultValue={
              multiple
                ? Array.isArray(value) && value.length > 0
                  ? value
                  : [defaultIntegracaoBancaria]
                : value
                  ? value
                  : defaultIntegracaoBancaria
            }
            getItemLabel={(item) => `${item.id} - ${item.nome_banco}`}
            onChange={(value) => {
              onChange(value as TConfiguracaoBancaria);
              handleClose();
            }}
          />
        </Dialog>
      )}
    </>
  );
}

interface SelectSimpleApiQueryProps {
  value: TConfiguracaoBancaria | TConfiguracaoBancaria[] | null;
  onChange: (arg: TConfiguracaoBancaria | null) => void;
  required?: boolean;
  error?: boolean;
  possuiBtnLimpar?: boolean;
  multiple?: boolean;
  extraParams?: { [key: string]: any };
  label?: string;
}
